var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "steen",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "poleerte granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "poleerte diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "poleerte andesit",
  "block.minecraft.grass_block": "gräsblok",
  "block.minecraft.dirt": "äer",
  "block.minecraft.coarse_dirt": "gruowe äer",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "purpuroot-nezel",
  "block.minecraft.warped_nylium": "wier-nezel",
  "block.minecraft.cobblestone": "brööksteen",
  "block.minecraft.oak_planks": "ekenholtbreden",
  "block.minecraft.spruce_planks": "füchtenholtbreden",
  "block.minecraft.birch_planks": "biäkenholtbreden",
  "block.minecraft.jungle_planks": "oorwooldholtbreden",
  "block.minecraft.acacia_planks": "akacienholtbreden",
  "block.minecraft.dark_oak_planks": "swatekenholtbreden",
  "block.minecraft.crimson_planks": "purpurrootbreden",
  "block.minecraft.warped_planks": "wierbreden",
  "block.minecraft.oak_sapling": "ekensetter",
  "block.minecraft.spruce_sapling": "füchtensetter",
  "block.minecraft.birch_sapling": "biäkensetter",
  "block.minecraft.jungle_sapling": "oorwooldsetter",
  "block.minecraft.acacia_sapling": "akatsiensetter",
  "block.minecraft.dark_oak_sapling": "swatekensetter",
  "block.minecraft.bedrock": "grundsteen",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rooter sand",
  "block.minecraft.gravel": "grand",
  "block.minecraft.gold_ore": "güldärts",
  "block.minecraft.iron_ore": "isenärts",
  "block.minecraft.coal_ore": "steenkuole",
  "block.minecraft.nether_gold_ore": "nethergüldärts",
  "block.minecraft.oak_log": "ekenstam",
  "block.minecraft.spruce_log": "füchtenstam",
  "block.minecraft.birch_log": "biäkenstam",
  "block.minecraft.jungle_log": "oorwooldstam",
  "block.minecraft.acacia_log": "akatsienstam",
  "block.minecraft.dark_oak_log": "swatekenstam",
  "block.minecraft.crimson_stem": "purpurootplant",
  "block.minecraft.warped_stem": "wierstam",
  "block.minecraft.stripped_oak_log": "entbarked ekenstam",
  "block.minecraft.stripped_spruce_log": "entbarked füchtenstam",
  "block.minecraft.stripped_birch_log": "entbarked biäkenstam",
  "block.minecraft.stripped_jungle_log": "entbarked oorwooldstam",
  "block.minecraft.stripped_acacia_log": "entbarked akatsienstam",
  "block.minecraft.stripped_dark_oak_log": "entbarked swatekenstam",
  "block.minecraft.stripped_crimson_stem": "entbarked purpurootstam",
  "block.minecraft.stripped_warped_stem": "entbarked wierstam",
  "block.minecraft.stripped_oak_wood": "entbarked ekenholt",
  "block.minecraft.stripped_spruce_wood": "entbarked füchtenholt",
  "block.minecraft.stripped_birch_wood": "entbarked biäkenholt",
  "block.minecraft.stripped_jungle_wood": "entbarked oorwooldholt",
  "block.minecraft.stripped_acacia_wood": "entbarked akatsienholt",
  "block.minecraft.stripped_dark_oak_wood": "entbarked swatekenholt",
  "block.minecraft.stripped_crimson_hyphae": "entbarked purpuroothyphen",
  "block.minecraft.stripped_warped_hyphae": "entbarked wierhyphen",
  "block.minecraft.oak_wood": "ekenholt",
  "block.minecraft.spruce_wood": "füchtenholt",
  "block.minecraft.birch_wood": "biäkenholt",
  "block.minecraft.jungle_wood": "oorwooldholt",
  "block.minecraft.acacia_wood": "akatsienholt",
  "block.minecraft.dark_oak_wood": "swatekenholt",
  "block.minecraft.crimson_hyphae": "purpuroothyphen",
  "block.minecraft.warped_hyphae": "wierhyphen",
  "block.minecraft.oak_leaves": "ekenbliäder",
  "block.minecraft.spruce_leaves": "füchtennadeln",
  "block.minecraft.birch_leaves": "biäkenbliäder",
  "block.minecraft.jungle_leaves": "oorwooldbliäder",
  "block.minecraft.acacia_leaves": "akatsienbliäder",
  "block.minecraft.dark_oak_leaves": "swatekenbliäder",
  "block.minecraft.sponge": "swamm",
  "block.minecraft.wet_sponge": "natter swamm",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapislatsuliärts",
  "block.minecraft.lapis_block": "lapislatsuliblok",
  "block.minecraft.dispenser": "audomaat",
  "block.minecraft.sandstone": "sandsteen",
  "block.minecraft.chiseled_sandstone": "baitelt sandsteen",
  "block.minecraft.cut_sandstone": "snieden sandsteen",
  "block.minecraft.note_block": "mussikblok",
  "block.minecraft.powered_rail": "stroomschine",
  "block.minecraft.detector_rail": "fölerschine",
  "block.minecraft.sticky_piston": "kliëwriger stempel",
  "block.minecraft.cobweb": "spinkopnöst",
  "block.minecraft.grass": "gräs",
  "block.minecraft.fern": "faon",
  "block.minecraft.dead_bush": "dooter busk",
  "block.minecraft.seagrass": "kroos",
  "block.minecraft.sea_pickle": "seegurk",
  "block.minecraft.piston": "stempel",
  "block.minecraft.white_wool": "witte wulle",
  "block.minecraft.orange_wool": "geelroote wulle",
  "block.minecraft.magenta_wool": "magenta wulle",
  "block.minecraft.light_blue_wool": "lechtblaoe wulle",
  "block.minecraft.yellow_wool": "geele wulle",
  "block.minecraft.lime_wool": "lechtgrööne wulle",
  "block.minecraft.pink_wool": "fienroote wulle",
  "block.minecraft.gray_wool": "graoe wulle",
  "block.minecraft.light_gray_wool": "griese wulle",
  "block.minecraft.cyan_wool": "blaogrööne wulle",
  "block.minecraft.purple_wool": "vigelette wulle",
  "block.minecraft.blue_wool": "blaoe wulle",
  "block.minecraft.brown_wool": "bruune wulle",
  "block.minecraft.green_wool": "grööne wulle",
  "block.minecraft.red_wool": "roote wulle",
  "block.minecraft.black_wool": "swatte wulle",
  "block.minecraft.dandelion": "kiëdenblome",
  "block.minecraft.poppy": "maon",
  "block.minecraft.blue_orchid": "blaoe orchidee",
  "block.minecraft.allium": "stäänlauk",
  "block.minecraft.azure_bluet": "blao porslainenstäänken",
  "block.minecraft.red_tulip": "roote tulp",
  "block.minecraft.orange_tulip": "geelroote tulp",
  "block.minecraft.white_tulip": "witte tulp",
  "block.minecraft.pink_tulip": "fienroote tulp",
  "block.minecraft.oxeye_daisy": "rüenblome",
  "block.minecraft.cornflower": "koornblööm",
  "block.minecraft.lily_of_the_valley": "maiklockje",
  "block.minecraft.wither_rose": "wither-roos",
  "block.minecraft.brown_mushroom": "bruune poggenstool",
  "block.minecraft.red_mushroom": "roote poggenstool",
  "block.minecraft.crimson_fungus": "purpurootpilz",
  "block.minecraft.warped_fungus": "wierpilz",
  "block.minecraft.crimson_roots": "purpurootwörteln",
  "block.minecraft.warped_roots": "wierwörteln",
  "block.minecraft.nether_sprouts": "nethersproden",
  "block.minecraft.weeping_vines": "truerranken",
  "block.minecraft.twisting_vines": "zwirbelranken",
  "block.minecraft.sugar_cane": "suckerrör",
  "block.minecraft.kelp": "tang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "güldblok",
  "block.minecraft.iron_block": "isenblok",
  "block.minecraft.oak_slab": "ekenplaat",
  "block.minecraft.spruce_slab": "füchtenholtplaat",
  "block.minecraft.birch_slab": "biäkenholtplaat",
  "block.minecraft.jungle_slab": "oorwooldholtplaat",
  "block.minecraft.acacia_slab": "akatsienholtplaat",
  "block.minecraft.dark_oak_slab": "swatekenholtplaat",
  "block.minecraft.crimson_slab": "purpurootplaat",
  "block.minecraft.warped_slab": "wierplaat",
  "block.minecraft.stone_slab": "steenplaat",
  "block.minecraft.smooth_stone_slab": "glatte steenplaat",
  "block.minecraft.sandstone_slab": "sandsteenplaat",
  "block.minecraft.cut_sandstone_slab": "snieden sandsteenplaat",
  "block.minecraft.petrified_oak_slab": "verstenert ekenholtplaat",
  "block.minecraft.cobblestone_slab": "brööksteenplaat",
  "block.minecraft.brick_slab": "tegelplaat",
  "block.minecraft.stone_brick_slab": "steentegelplaat",
  "block.minecraft.nether_brick_slab": "nethertegelplaat",
  "block.minecraft.quartz_slab": "kwartsplaat",
  "block.minecraft.red_sandstone_slab": "roote sandsteenplaat",
  "block.minecraft.cut_red_sandstone_slab": "snieden roote sandsteenplaat",
  "block.minecraft.purpur_slab": "purpurplaat",
  "block.minecraft.prismarine_slab": "prismarienplaat",
  "block.minecraft.prismarine_brick_slab": "prismarientegelplaat",
  "block.minecraft.dark_prismarine_slab": "düüster prismarienplaat",
  "block.minecraft.smooth_quartz": "glatter kwartsblok",
  "block.minecraft.smooth_red_sandstone": "glatter rooter sandsteen",
  "block.minecraft.smooth_sandstone": "glatter sandsteen",
  "block.minecraft.smooth_stone": "glatter steen",
  "block.minecraft.bricks": "tegelsteen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bökerschap",
  "block.minecraft.mossy_cobblestone": "mussige plaostersteen",
  "block.minecraft.obsidian": "gnetersteen",
  "block.minecraft.torch": "lunt",
  "block.minecraft.end_rod": "endstaav",
  "block.minecraft.chorus_plant": "chorusplant",
  "block.minecraft.chorus_flower": "chorusblööt",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpursüle",
  "block.minecraft.purpur_stairs": "purpurtrapp",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "ekenholttrapp",
  "block.minecraft.chest": "truh",
  "block.minecraft.diamond_ore": "demantärts",
  "block.minecraft.diamond_block": "demantblok",
  "block.minecraft.crafting_table": "wiärkbank",
  "block.minecraft.farmland": "plügland",
  "block.minecraft.furnace": "aven",
  "block.minecraft.ladder": "ledder",
  "block.minecraft.rail": "schine",
  "block.minecraft.cobblestone_stairs": "brööksteentrapp",
  "block.minecraft.lever": "hiäwel",
  "block.minecraft.stone_pressure_plate": "steendrükplaat",
  "block.minecraft.oak_pressure_plate": "ekenholtdrukplaat",
  "block.minecraft.spruce_pressure_plate": "füchtenholtdrukplaat",
  "block.minecraft.birch_pressure_plate": "biäkenholtdrukplaat",
  "block.minecraft.jungle_pressure_plate": "oorwooldholtdrukplaat",
  "block.minecraft.acacia_pressure_plate": "akatsienholtdrukplaat",
  "block.minecraft.dark_oak_pressure_plate": "swatekenholtdrukplaat",
  "block.minecraft.crimson_pressure_plate": "purpurootdrukplaat",
  "block.minecraft.warped_pressure_plate": "wierdrukplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "poleerte swatsteendrukplaat",
  "block.minecraft.redstone_ore": "redstone-ärts",
  "block.minecraft.redstone_torch": "redstone-lunt",
  "block.minecraft.snow": "snee",
  "block.minecraft.ice": "ies",
  "block.minecraft.snow_block": "sneeblok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "klai",
  "block.minecraft.jukebox": "grammofoon",
  "block.minecraft.oak_fence": "ekenholttuun",
  "block.minecraft.spruce_fence": "füchtenholttuun",
  "block.minecraft.birch_fence": "biäkentuun",
  "block.minecraft.jungle_fence": "oorwooldtuun",
  "block.minecraft.acacia_fence": "akatsienholttuun",
  "block.minecraft.dark_oak_fence": "swatekenholttuun",
  "block.minecraft.crimson_fence": "purpuroottuun",
  "block.minecraft.warped_fence": "wiertuun",
  "block.minecraft.pumpkin": "kävers",
  "block.minecraft.carved_pumpkin": "snidden kävers",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "siälensand",
  "block.minecraft.soul_soil": "siälenäer",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "poleerter basalt",
  "block.minecraft.soul_torch": "siälenlunt",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "käverslücht",
  "block.minecraft.oak_trapdoor": "ekenholtluuk",
  "block.minecraft.spruce_trapdoor": "füchtenholtluuk",
  "block.minecraft.birch_trapdoor": "biäkenholtluuk",
  "block.minecraft.jungle_trapdoor": "oorwooldholtluuk",
  "block.minecraft.acacia_trapdoor": "akatsienholtluuk",
  "block.minecraft.dark_oak_trapdoor": "swatekenholtluuk",
  "block.minecraft.crimson_trapdoor": "purpurootluuk",
  "block.minecraft.warped_trapdoor": "wierluuk",
  "block.minecraft.infested_stone": "befallener steen",
  "block.minecraft.infested_cobblestone": "befallener brööksteen",
  "block.minecraft.infested_stone_bricks": "befallene steentegel",
  "block.minecraft.infested_mossy_stone_bricks": "befallene mussige steentegel",
  "block.minecraft.infested_cracked_stone_bricks": "befallene bürstige steentegel",
  "block.minecraft.infested_chiseled_stone_bricks": "befallene baitelte steentegel",
  "block.minecraft.stone_bricks": "steentegels",
  "block.minecraft.mossy_stone_bricks": "mussige steentegel",
  "block.minecraft.cracked_stone_bricks": "bürstige steentegel",
  "block.minecraft.chiseled_stone_bricks": "baitelte steentegel",
  "block.minecraft.brown_mushroom_block": "bruune poggenstoolblok",
  "block.minecraft.red_mushroom_block": "roote poggenstoolblok",
  "block.minecraft.mushroom_stem": "poggenstoolsteel",
  "block.minecraft.iron_bars": "isentralg",
  "block.minecraft.chain": "kädde",
  "block.minecraft.glass_pane": "glasschiwe",
  "block.minecraft.melon": "meloon",
  "block.minecraft.vine": "ranken",
  "block.minecraft.oak_fence_gate": "ekenholttuunpaort",
  "block.minecraft.spruce_fence_gate": "füchtenholttuunpaort",
  "block.minecraft.birch_fence_gate": "biäkenholttuunpaort",
  "block.minecraft.jungle_fence_gate": "oorwooldtuunpaort",
  "block.minecraft.acacia_fence_gate": "akatsienholttuunpaort",
  "block.minecraft.dark_oak_fence_gate": "swatekenholttuunpaort",
  "block.minecraft.crimson_fence_gate": "purpuroottuunpaort",
  "block.minecraft.warped_fence_gate": "wiertuunpaort",
  "block.minecraft.brick_stairs": "tegeltrapp",
  "block.minecraft.stone_brick_stairs": "steentegeltrapp",
  "block.minecraft.mycelium": "mütseel",
  "block.minecraft.lily_pad": "waterrausenblad",
  "block.minecraft.nether_bricks": "nethertegel",
  "block.minecraft.cracked_nether_bricks": "bürstige nethertegel",
  "block.minecraft.chiseled_nether_bricks": "baitelte nethertegel",
  "block.minecraft.nether_brick_fence": "nethertegeltuun",
  "block.minecraft.nether_brick_stairs": "nethertegeltrapp",
  "block.minecraft.enchanting_table": "betöverungstafel",
  "block.minecraft.end_portal_frame": "endpaortaalraam",
  "block.minecraft.end_stone": "endsteen",
  "block.minecraft.end_stone_bricks": "endsteentegel",
  "block.minecraft.dragon_egg": "draakei",
  "block.minecraft.redstone_lamp": "redstone-lamp",
  "block.minecraft.sandstone_stairs": "sandsteentrapp",
  "block.minecraft.emerald_ore": "smaragdärts",
  "block.minecraft.ender_chest": "endertruh",
  "block.minecraft.tripwire_hook": "haken",
  "block.minecraft.emerald_block": "smaragdblok",
  "block.minecraft.spruce_stairs": "füchtenholttrapp",
  "block.minecraft.birch_stairs": "biäkenholttrapp",
  "block.minecraft.jungle_stairs": "oorwooldholttrapp",
  "block.minecraft.crimson_stairs": "purpuroottrapp",
  "block.minecraft.warped_stairs": "wiertrapp",
  "block.minecraft.command_block": "befiälsblok",
  "block.minecraft.beacon": "löchtfüer",
  "block.minecraft.cobblestone_wall": "brööksteenmüer",
  "block.minecraft.mossy_cobblestone_wall": "mussige brööksteenmüer",
  "block.minecraft.brick_wall": "tegelmüer",
  "block.minecraft.prismarine_wall": "prismarienmüer",
  "block.minecraft.red_sandstone_wall": "roote sandsteenmüer",
  "block.minecraft.mossy_stone_brick_wall": "mussige steentegelmüer",
  "block.minecraft.granite_wall": "granitmüer",
  "block.minecraft.stone_brick_wall": "steentegelmüer",
  "block.minecraft.nether_brick_wall": "nethertegelmüer",
  "block.minecraft.andesite_wall": "andesitmüer",
  "block.minecraft.red_nether_brick_wall": "roote nethertegelmüer",
  "block.minecraft.sandstone_wall": "sandsteenmüer",
  "block.minecraft.end_stone_brick_wall": "endsteentegelmüer",
  "block.minecraft.diorite_wall": "dioritmüer",
  "block.minecraft.blackstone_wall": "swatsteenmüer",
  "block.minecraft.polished_blackstone_wall": "poleerte swatsteenmüer",
  "block.minecraft.polished_blackstone_brick_wall": "poleerte swatsteentegelmüer",
  "block.minecraft.stone_button": "steenknop",
  "block.minecraft.oak_button": "ekenholtknop",
  "block.minecraft.spruce_button": "füchtenholtknop",
  "block.minecraft.birch_button": "biäkenholtknop",
  "block.minecraft.jungle_button": "oorwooldholtknop",
  "block.minecraft.acacia_button": "akatsienholtknop",
  "block.minecraft.dark_oak_button": "swatekenholtknop",
  "block.minecraft.crimson_button": "purpurootknop",
  "block.minecraft.warped_button": "wierknop",
  "block.minecraft.polished_blackstone_button": "poleerter swatsteenknop",
  "block.minecraft.anvil": "ambold",
  "block.minecraft.chipped_anvil": "afbrakt ambold",
  "block.minecraft.damaged_anvil": "vönailter ambold",
  "block.minecraft.trapped_chest": "redstonetruh",
  "block.minecraft.light_weighted_pressure_plate": "lichtwichtigdrukplaat",
  "block.minecraft.heavy_weighted_pressure_plate": "swaarwichtigdrukplaat",
  "block.minecraft.daylight_detector": "dageslechtföler",
  "block.minecraft.redstone_block": "redstone-blok",
  "block.minecraft.nether_quartz_ore": "netherquartzärts",
  "block.minecraft.hopper": "trächter",
  "block.minecraft.chiseled_quartz_block": "baitelter kwartsblok",
  "block.minecraft.quartz_block": "kwartsblok",
  "block.minecraft.quartz_bricks": "kwartstegel",
  "block.minecraft.quartz_pillar": "kwartssüle",
  "block.minecraft.quartz_stairs": "kwartstrapp",
  "block.minecraft.activator_rail": "ankriegschine",
  "block.minecraft.dropper": "giëwer",
  "block.minecraft.white_terracotta": "witte keramik",
  "block.minecraft.orange_terracotta": "geelroote keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "lechtblaoe keramik",
  "block.minecraft.yellow_terracotta": "geele keramik",
  "block.minecraft.lime_terracotta": "lechtgrööne keramik",
  "block.minecraft.pink_terracotta": "fienroote keramik",
  "block.minecraft.gray_terracotta": "graoe keramik",
  "block.minecraft.light_gray_terracotta": "griese keramik",
  "block.minecraft.cyan_terracotta": "blaogrööne keramik",
  "block.minecraft.purple_terracotta": "vigelette keramik",
  "block.minecraft.blue_terracotta": "blaoe keramik",
  "block.minecraft.brown_terracotta": "bruune keramik",
  "block.minecraft.green_terracotta": "grööne keramik",
  "block.minecraft.red_terracotta": "roote keramik",
  "block.minecraft.black_terracotta": "swatte keramik",
  "block.minecraft.barrier": "barreer",
  "block.minecraft.iron_trapdoor": "isenluuk",
  "block.minecraft.hay_block": "haidut",
  "block.minecraft.white_carpet": "witte teppich",
  "block.minecraft.orange_carpet": "geelrooter teppich",
  "block.minecraft.magenta_carpet": "magenta teppich",
  "block.minecraft.light_blue_carpet": "lechtblaoer teppich",
  "block.minecraft.yellow_carpet": "geeler teppich",
  "block.minecraft.lime_carpet": "lechtgrööner teppich",
  "block.minecraft.pink_carpet": "fienrooter teppich",
  "block.minecraft.gray_carpet": "graoer teppich",
  "block.minecraft.light_gray_carpet": "grieser teppich",
  "block.minecraft.cyan_carpet": "blaogrööner teppich",
  "block.minecraft.purple_carpet": "vigeletter teppich",
  "block.minecraft.blue_carpet": "blaoer teppich",
  "block.minecraft.brown_carpet": "bruner teppich",
  "block.minecraft.green_carpet": "grööner teppich",
  "block.minecraft.red_carpet": "rooter teppich",
  "block.minecraft.black_carpet": "swatter teppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kuoleblok",
  "block.minecraft.packed_ice": "pakies",
  "block.minecraft.acacia_stairs": "akatsienholttrapp",
  "block.minecraft.dark_oak_stairs": "swatekenholttrapp",
  "block.minecraft.slime_block": "sliemblok",
  "block.minecraft.grass_path": "tramppadd",
  "block.minecraft.sunflower": "sünnenbloom",
  "block.minecraft.lilac": "nagelblome",
  "block.minecraft.rose_bush": "rausenbusk",
  "block.minecraft.peony": "pinkstrause",
  "block.minecraft.tall_grass": "hooget gras",
  "block.minecraft.large_fern": "graut faon",
  "block.minecraft.white_stained_glass": "wit glas",
  "block.minecraft.orange_stained_glass": "geelrootes glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "lechtblaoes glas",
  "block.minecraft.yellow_stained_glass": "geeles glas",
  "block.minecraft.lime_stained_glass": "lechtgröönes glas",
  "block.minecraft.pink_stained_glass": "fienrootes glas",
  "block.minecraft.gray_stained_glass": "graoes glas",
  "block.minecraft.light_gray_stained_glass": "grieses glas",
  "block.minecraft.cyan_stained_glass": "blaogröönes glas",
  "block.minecraft.purple_stained_glass": "vigelettes glas",
  "block.minecraft.blue_stained_glass": "blaoes glas",
  "block.minecraft.brown_stained_glass": "bruunes glas",
  "block.minecraft.green_stained_glass": "gröönes glas",
  "block.minecraft.red_stained_glass": "rootes glas",
  "block.minecraft.black_stained_glass": "swattes glas",
  "block.minecraft.white_stained_glass_pane": "witte glasschiwe",
  "block.minecraft.orange_stained_glass_pane": "geelroote glasschiwe",
  "block.minecraft.magenta_stained_glass_pane": "magenta glasschiwe",
  "block.minecraft.light_blue_stained_glass_pane": "lechtblaoe glasschiwe",
  "block.minecraft.yellow_stained_glass_pane": "geele glasschiwe",
  "block.minecraft.lime_stained_glass_pane": "lechtgrööne glasschiwe",
  "block.minecraft.pink_stained_glass_pane": "fienroote glasschiwe",
  "block.minecraft.gray_stained_glass_pane": "graoe glasschiwe",
  "block.minecraft.light_gray_stained_glass_pane": "griese glasschiwe",
  "block.minecraft.cyan_stained_glass_pane": "blaogrööne glasschiwe",
  "block.minecraft.purple_stained_glass_pane": "vigelette glasschiwe",
  "block.minecraft.blue_stained_glass_pane": "blaoe glasschiwe",
  "block.minecraft.brown_stained_glass_pane": "brune glasschiwe",
  "block.minecraft.green_stained_glass_pane": "grööne glasschiwe",
  "block.minecraft.red_stained_glass_pane": "roote glasschiwe",
  "block.minecraft.black_stained_glass_pane": "swatte glasschiwe",
  "block.minecraft.prismarine": "prismarien",
  "block.minecraft.prismarine_bricks": "prismarientegel",
  "block.minecraft.dark_prismarine": "düüster prismarien",
  "block.minecraft.prismarine_stairs": "prismarientrapp",
  "block.minecraft.prismarine_brick_stairs": "prismarientegeltrapp",
  "block.minecraft.dark_prismarine_stairs": "düüster prismarientrapp",
  "block.minecraft.sea_lantern": "selatüchte",
  "block.minecraft.red_sandstone": "rooter sandsteen",
  "block.minecraft.chiseled_red_sandstone": "baitelte roote sandsteen",
  "block.minecraft.cut_red_sandstone": "snieden roote sandsteen",
  "block.minecraft.red_sandstone_stairs": "roote sandsteentrapp",
  "block.minecraft.repeating_command_block": "wedderhal-befiälsblok",
  "block.minecraft.chain_command_block": "kädden-befiälsblök",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "netherwaartenblok",
  "block.minecraft.warped_wart_block": "wierwaartenblok",
  "block.minecraft.red_nether_bricks": "roote nethertegel",
  "block.minecraft.bone_block": "beenblok",
  "block.minecraft.structure_void": "bauwiärksleege",
  "block.minecraft.observer": "waarnemer",
  "block.minecraft.shulker_box": "shulker-kist",
  "block.minecraft.white_shulker_box": "witte shulker-kist",
  "block.minecraft.orange_shulker_box": "geelroote shulker-kist",
  "block.minecraft.magenta_shulker_box": "magenta shulker-kist",
  "block.minecraft.light_blue_shulker_box": "lechtblaoe shulker-kist",
  "block.minecraft.yellow_shulker_box": "geele shulker-kist",
  "block.minecraft.lime_shulker_box": "lechtgrööne shulker-kist",
  "block.minecraft.pink_shulker_box": "fienroote shulker-kist",
  "block.minecraft.gray_shulker_box": "graoe shulker-kist",
  "block.minecraft.light_gray_shulker_box": "griese shulker-kist",
  "block.minecraft.cyan_shulker_box": "blaogrööne shulker-kist",
  "block.minecraft.purple_shulker_box": "vigelette shulker-kist",
  "block.minecraft.blue_shulker_box": "blaoe shulker-kist",
  "block.minecraft.brown_shulker_box": "bruune shulker-kist",
  "block.minecraft.green_shulker_box": "grööne shulker-kist",
  "block.minecraft.red_shulker_box": "roote shulker-kist",
  "block.minecraft.black_shulker_box": "swatte shulker-kist",
  "block.minecraft.white_glazed_terracotta": "witte glaseerte keramik",
  "block.minecraft.orange_glazed_terracotta": "geelroote glaseerte keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glaseerte keramik",
  "block.minecraft.light_blue_glazed_terracotta": "lechtblaoe glaseerte keramik",
  "block.minecraft.yellow_glazed_terracotta": "geele glaseerte keramik",
  "block.minecraft.lime_glazed_terracotta": "lechtgrööne glaseerte keramik",
  "block.minecraft.pink_glazed_terracotta": "fienroote glaseerte keramik",
  "block.minecraft.gray_glazed_terracotta": "graoe glaseerte keramik",
  "block.minecraft.light_gray_glazed_terracotta": "griese glaseerte keramik",
  "block.minecraft.cyan_glazed_terracotta": "blaogrööne glaseerte keramik",
  "block.minecraft.purple_glazed_terracotta": "vigelette glaseerte keramik",
  "block.minecraft.blue_glazed_terracotta": "blaoe glaseerte keramik",
  "block.minecraft.brown_glazed_terracotta": "bruune glaseerte keramik",
  "block.minecraft.green_glazed_terracotta": "grööne glaseerte keramik",
  "block.minecraft.red_glazed_terracotta": "roote glaseerte keramik",
  "block.minecraft.black_glazed_terracotta": "swatte glaseerte keramik",
  "block.minecraft.white_concrete": "witter beton",
  "block.minecraft.orange_concrete": "geelrooter beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "lechtblaoer beton",
  "block.minecraft.yellow_concrete": "geeler beton",
  "block.minecraft.lime_concrete": "lechtgrööner beton",
  "block.minecraft.pink_concrete": "fienrooter beton",
  "block.minecraft.gray_concrete": "graoer beton",
  "block.minecraft.light_gray_concrete": "grieser beton",
  "block.minecraft.cyan_concrete": "blaogrööner beton",
  "block.minecraft.purple_concrete": "vigeletter beton",
  "block.minecraft.blue_concrete": "blaoer beton",
  "block.minecraft.brown_concrete": "bruuner beton",
  "block.minecraft.green_concrete": "grööner beton",
  "block.minecraft.red_concrete": "rooter beton",
  "block.minecraft.black_concrete": "swatter beton",
  "block.minecraft.white_concrete_powder": "witter dröögbeton",
  "block.minecraft.orange_concrete_powder": "geelrooter dröögbeton",
  "block.minecraft.magenta_concrete_powder": "magenta dröögbeton",
  "block.minecraft.light_blue_concrete_powder": "lechtblaoer dröögbeton",
  "block.minecraft.yellow_concrete_powder": "geeler dröögbeton",
  "block.minecraft.lime_concrete_powder": "lechtgrööner dröögbeton",
  "block.minecraft.pink_concrete_powder": "fienrooter dröögbeton",
  "block.minecraft.gray_concrete_powder": "graoer dröögbeton",
  "block.minecraft.light_gray_concrete_powder": "grieser dröögbeton",
  "block.minecraft.cyan_concrete_powder": "blaogrööner dröögbeton",
  "block.minecraft.purple_concrete_powder": "vigeletter dröögbeton",
  "block.minecraft.blue_concrete_powder": "blaoer dröögbeton",
  "block.minecraft.brown_concrete_powder": "bruuner dröögbeton",
  "block.minecraft.green_concrete_powder": "grööner dröögbeton",
  "block.minecraft.red_concrete_powder": "rooter dröögbeton",
  "block.minecraft.black_concrete_powder": "swatter dröögbeton",
  "block.minecraft.turtle_egg": "skildpadai",
  "block.minecraft.dead_tube_coral_block": "dooter röhrkorallblok",
  "block.minecraft.dead_brain_coral_block": "dooter bregenkorallblok",
  "block.minecraft.dead_bubble_coral_block": "doote blaasnkorallblok",
  "block.minecraft.dead_fire_coral_block": "dooter füerkorallblok",
  "block.minecraft.dead_horn_coral_block": "doote hoornkorallblok",
  "block.minecraft.tube_coral_block": "röhrkorallblok",
  "block.minecraft.brain_coral_block": "bregenkorallblok",
  "block.minecraft.bubble_coral_block": "blaasnkorallblok",
  "block.minecraft.fire_coral_block": "füerkorallblok",
  "block.minecraft.horn_coral_block": "hoornkorallblok",
  "block.minecraft.tube_coral": "röhrkorall",
  "block.minecraft.brain_coral": "bregenkorall",
  "block.minecraft.bubble_coral": "blaasnkorall",
  "block.minecraft.fire_coral": "füerkorall",
  "block.minecraft.horn_coral": "hoornkorall",
  "block.minecraft.dead_brain_coral": "doote bregenkorall",
  "block.minecraft.dead_bubble_coral": "doote blaasnkorall",
  "block.minecraft.dead_fire_coral": "doote füerkorall",
  "block.minecraft.dead_horn_coral": "doote hoornkorall",
  "block.minecraft.dead_tube_coral": "doote röhrkorall",
  "block.minecraft.tube_coral_fan": "röhrkorallwaier",
  "block.minecraft.brain_coral_fan": "bregenkorallwaier",
  "block.minecraft.bubble_coral_fan": "blaasnkorallwaier",
  "block.minecraft.fire_coral_fan": "füerkorallwaier",
  "block.minecraft.horn_coral_fan": "doote hoornkorallwaier",
  "block.minecraft.dead_tube_coral_fan": "dooter röhrkorallwaier",
  "block.minecraft.dead_brain_coral_fan": "dooter bregenkorallwaier",
  "block.minecraft.dead_bubble_coral_fan": "doote blaasnkorallwaier",
  "block.minecraft.dead_fire_coral_fan": "dooter füerkorallwaier",
  "block.minecraft.dead_horn_coral_fan": "doote hoornkorallwaier",
  "block.minecraft.blue_ice": "blaoies",
  "block.minecraft.conduit": "akwisator",
  "block.minecraft.polished_granite_stairs": "poleerte granittrapp",
  "block.minecraft.smooth_red_sandstone_stairs": "glatte roote sandsteentrapp",
  "block.minecraft.mossy_stone_brick_stairs": "mussige steentegeltrapp",
  "block.minecraft.polished_diorite_stairs": "poleerte diorittrapp",
  "block.minecraft.mossy_cobblestone_stairs": "mussige brööksteentrapp",
  "block.minecraft.end_stone_brick_stairs": "endsteentegeltrapp",
  "block.minecraft.stone_stairs": "steentrapp",
  "block.minecraft.smooth_sandstone_stairs": "glatte sandsteentrapp",
  "block.minecraft.smooth_quartz_stairs": "glatte kwartstrapp",
  "block.minecraft.granite_stairs": "granittrapp",
  "block.minecraft.andesite_stairs": "andesittrapp",
  "block.minecraft.red_nether_brick_stairs": "roote nethertegeltrapp",
  "block.minecraft.polished_andesite_stairs": "poleerte andesittrapp",
  "block.minecraft.diorite_stairs": "diorittrapp",
  "block.minecraft.polished_granite_slab": "poleerte granitplaat",
  "block.minecraft.smooth_red_sandstone_slab": "glatte roote sandsteenplaat",
  "block.minecraft.mossy_stone_brick_slab": "mussige steentegelplaat",
  "block.minecraft.polished_diorite_slab": "poleerte dioritplaat",
  "block.minecraft.mossy_cobblestone_slab": "mussige brööksteenplaat",
  "block.minecraft.end_stone_brick_slab": "endsteentegelplaat",
  "block.minecraft.smooth_sandstone_slab": "glatte sandsteenplaat",
  "block.minecraft.smooth_quartz_slab": "glatte kwartsplaat",
  "block.minecraft.granite_slab": "granitplaat",
  "block.minecraft.andesite_slab": "andesitplaat",
  "block.minecraft.red_nether_brick_slab": "roote nethertegelplaat",
  "block.minecraft.polished_andesite_slab": "poleerte andesitplaat",
  "block.minecraft.diorite_slab": "diorittrapp",
  "block.minecraft.scaffolding": "gerüst",
  "block.minecraft.iron_door": "isendüör",
  "block.minecraft.oak_door": "ekendüör",
  "block.minecraft.spruce_door": "füchtendüör",
  "block.minecraft.birch_door": "biäkendüör",
  "block.minecraft.jungle_door": "oorwoolddüör",
  "block.minecraft.acacia_door": "akatsiendüör",
  "block.minecraft.dark_oak_door": "swatekendüör",
  "block.minecraft.crimson_door": "purpurootdüör",
  "block.minecraft.warped_door": "wierdüör",
  "block.minecraft.repeater": "redstone-verstarker",
  "block.minecraft.comparator": "redstone-komparator",
  "block.minecraft.structure_block": "bauwiärksblok",
  "block.minecraft.jigsaw": "verbünnelblok",
  "item.minecraft.turtle_helmet": "skildpadskild□□op ’n kopp:□+2 rüst",
  "item.minecraft.scute": "hoornschild",
  "item.minecraft.iron_shovel": "isenschöfel□□in de hööfthand:□+3.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.iron_pickaxe": "isenbicke□□in de hööfthand:□+3 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.iron_axe": "isenäkse□□in de hööfthand:□+8 anslagsschaden□-3.1 angriffgauigkait",
  "item.minecraft.flint_and_steel": "füertüüg",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "buogen",
  "item.minecraft.arrow": "piel",
  "item.minecraft.coal": "kuole",
  "item.minecraft.charcoal": "holtkuole",
  "item.minecraft.diamond": "demant",
  "item.minecraft.iron_ingot": "isenbarren",
  "item.minecraft.gold_ingot": "güldbarren",
  "item.minecraft.netherite_ingot": "netheritbarren",
  "item.minecraft.netherite_scrap": "netheritplaten",
  "item.minecraft.iron_sword": "isenswiärt□□in de hööfthand:□+5 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.wooden_sword": "holtswiärt□□in de hööfthand:□+3 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.wooden_shovel": "holtschöfel□□in de hööfthand:□+1.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.wooden_pickaxe": "holtbicke□□in de hööfthand:□+1 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.wooden_axe": "holtäkse□□in de hööfthand:□+6 anslagsschaden□-3.2 angriffgauigkait",
  "item.minecraft.stone_sword": "steenswiärt□□in de hööfthand:□+4 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.stone_shovel": "steenschöfel□□in de hööfthand:□+2.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.stone_pickaxe": "steenbicke□□in de hööfthand:□+2 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.stone_axe": "steenäkse□□in de hööfthand:□+8 anslagsschaden□-3.2 angriffgauigkait",
  "item.minecraft.diamond_sword": "demantswiärt□□in de hööfthand:□+6 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.diamond_shovel": "demantschöfel□□in de hööfthand:□+4.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.diamond_pickaxe": "demantbicke□□in de hööfthand:□+4 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.diamond_axe": "demantext□□in de hööfthand:□+8 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.stick": "stok",
  "item.minecraft.bowl": "nap",
  "item.minecraft.mushroom_stew": "poggenstoolsup",
  "item.minecraft.golden_sword": "güldswiärt□□in de hööfthand:□+3 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.golden_shovel": "güldschöfel□□in de hööfthand:□+1.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.golden_pickaxe": "güldbicke□□in de hööfthand:□+1 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.golden_axe": "güldäkse□□in de hööfthand:□+6 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.netherite_sword": "netheritswiärt□□in de hööfthand:□+7 anslagsschaden□-2.4 angriffgauigkait",
  "item.minecraft.netherite_shovel": "netheritschöfel□□in de hööfthand:□+5.5 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.netherite_pickaxe": "netheritbicke□□in de hööfthand:□+5 anslagsschaden□-2.8 angriffgauigkait",
  "item.minecraft.netherite_axe": "netheritäkse□□in de hööfthand:□+9 anslagsschaden□-3 angriffgauigkait",
  "item.minecraft.string": "snoer",
  "item.minecraft.feather": "fiäder",
  "item.minecraft.gunpowder": "schaitpulwer",
  "item.minecraft.wooden_hoe": "holthak□□in de hööfthand:□-3 angriffgauigkait",
  "item.minecraft.stone_hoe": "steenhak□□in de hööfthand:□-2 angriffgauigkait",
  "item.minecraft.iron_hoe": "isenhak□□in de hööfthand:□-1 angriffgauigkait",
  "item.minecraft.diamond_hoe": "demanthaak□□in de hööfthand:",
  "item.minecraft.golden_hoe": "güldhak□□in de hööfthand:□-3 angriffgauigkait",
  "item.minecraft.netherite_hoe": "netherithak□□in de hööfthand:",
  "item.minecraft.wheat_seeds": "waitenkoorns",
  "item.minecraft.wheat": "waiten",
  "item.minecraft.bread": "braud",
  "item.minecraft.leather_helmet": "liäderkapp□□op ’n kopp:□+1 rüst",
  "item.minecraft.leather_chestplate": "liäderharnsch□□an ’n körper:□+3 rüst",
  "item.minecraft.leather_leggings": "liäderbükse□□an ’n been:□+2 rüst",
  "item.minecraft.leather_boots": "liäderstiëwels□□an ’n fööt:□+1 rüst",
  "item.minecraft.chainmail_helmet": "käddenhaavk□□op ’n kopp:□+2 rüst",
  "item.minecraft.chainmail_chestplate": "käddenbuorstplaat□□an ’n körper:□+5 rüst",
  "item.minecraft.chainmail_leggings": "käddenbükse□□an ’n been:□+4 rüst",
  "item.minecraft.chainmail_boots": "käddenstiëwels□□an ’n fööt:□+1 rüst",
  "item.minecraft.iron_helmet": "isenhelm□□op ’n kopp:□+2 rüst",
  "item.minecraft.iron_chestplate": "isenbuorstplaat□□an ’n körper:□+6 rüst",
  "item.minecraft.iron_leggings": "isenbükse□□an ’n been:□+5 rüst",
  "item.minecraft.iron_boots": "isenstiëwels□□an ’n fööt:□+2 rüst",
  "item.minecraft.diamond_helmet": "demanthelm□□op ’n kopp:□+3 rüst□+2 rüstshärt",
  "item.minecraft.diamond_chestplate": "demantbuorstplaat□□an ’n körper:□+8 rüst□+2 rüstshärt",
  "item.minecraft.diamond_leggings": "demantbükse□□an ’n been:□+6 rüst□+2 rüstshärt",
  "item.minecraft.diamond_boots": "demantstiëwels□□an ’n fööt:□+3 rüst□+2 rüstshärt",
  "item.minecraft.golden_helmet": "güldhelm□□op ’n kopp:□+2 rüst",
  "item.minecraft.golden_chestplate": "güldbuorstplaat□□an ’n körper:□+5 rüst",
  "item.minecraft.golden_leggings": "güldbükse□□an ’n been:□+3 rüst",
  "item.minecraft.golden_boots": "güldstiëwels□□an ’n fööt:□+1 rüst",
  "item.minecraft.netherite_helmet": "netherithelm□□op ’n kopp:□+3 rüst□+3 rüstshärt□+1 trügslagfasthait",
  "item.minecraft.netherite_chestplate": "netheritbuorstplaat□□an ’n körper:□+8 rüst□+3 rüstshärt□+1 trügslagfasthait",
  "item.minecraft.netherite_leggings": "netheritbükse□□an ’n been:□+6 rüst□+3 rüstshärt□+1 trügslagfasthait",
  "item.minecraft.netherite_boots": "netheritstiëwels□□an ’n fööt:□+3 rüst□+3 rüstshärt□+1 trügslagfasthait",
  "item.minecraft.flint": "füersteen",
  "item.minecraft.porkchop": "rauhet swienefleesk",
  "item.minecraft.cooked_porkchop": "brodten swienefleesk",
  "item.minecraft.painting": "beld",
  "item.minecraft.golden_apple": "güllener appel",
  "item.minecraft.enchanted_golden_apple": "betöverter güllener appel",
  "block.minecraft.oak_sign": "ekenholtschild",
  "block.minecraft.spruce_sign": "füchtenholtschild",
  "block.minecraft.birch_sign": "biäkenholtschild",
  "block.minecraft.jungle_sign": "oorwooldholtschild",
  "block.minecraft.acacia_sign": "akatsienholtschild",
  "block.minecraft.dark_oak_sign": "swatekenholtschild",
  "block.minecraft.crimson_sign": "purpurootschild",
  "block.minecraft.warped_sign": "wierschild",
  "item.minecraft.bucket": "emmer",
  "item.minecraft.water_bucket": "wateremmer",
  "item.minecraft.lava_bucket": "lawaemmer",
  "item.minecraft.minecart": "kipkaor",
  "item.minecraft.saddle": "saddel",
  "item.minecraft.redstone": "redstone-pulwer",
  "item.minecraft.snowball": "sneebal",
  "item.minecraft.oak_boat": "ekenholtbööd",
  "item.minecraft.leather": "liäder",
  "item.minecraft.milk_bucket": "melkemmer",
  "item.minecraft.pufferfish_bucket": "kugelfiskemmer",
  "item.minecraft.salmon_bucket": "lasemmer",
  "item.minecraft.cod_bucket": "kabeljauwemmer",
  "item.minecraft.tropical_fish_bucket": "tropenfiskemmer",
  "item.minecraft.brick": "tegel",
  "item.minecraft.clay_ball": "klaibal",
  "block.minecraft.dried_kelp_block": "dröger tangblok",
  "item.minecraft.paper": "papeer",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "sliembal",
  "item.minecraft.chest_minecart": "truhkaor",
  "item.minecraft.furnace_minecart": "driewkaor",
  "item.minecraft.egg": "ai",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "angelruut",
  "item.minecraft.clock": "klok",
  "item.minecraft.glowstone_dust": "glowstonepulwer",
  "item.minecraft.cod": "rauher kabeljauw",
  "item.minecraft.salmon": "rauher las",
  "item.minecraft.tropical_fish": "tropenfisk",
  "item.minecraft.pufferfish": "kugelfisk",
  "item.minecraft.cooked_cod": "brodten kabeljauw",
  "item.minecraft.cooked_salmon": "brodten las",
  "item.minecraft.ink_sac": "enksak",
  "item.minecraft.red_dye": "roote farve",
  "item.minecraft.green_dye": "grööne farve",
  "item.minecraft.cocoa_beans": "kakaubaunen",
  "item.minecraft.lapis_lazuli": "lapislatsuli",
  "item.minecraft.purple_dye": "vigelette farve",
  "item.minecraft.cyan_dye": "blaogrööne farve",
  "item.minecraft.light_gray_dye": "griese farve",
  "item.minecraft.gray_dye": "graoe farve",
  "item.minecraft.pink_dye": "fienroote farve",
  "item.minecraft.lime_dye": "lechtgrööne farve",
  "item.minecraft.yellow_dye": "geele farve",
  "item.minecraft.light_blue_dye": "lechtblaoe farve",
  "item.minecraft.magenta_dye": "magenta farve",
  "item.minecraft.orange_dye": "geelroote farve",
  "item.minecraft.bone_meal": "beenmiäl",
  "item.minecraft.blue_dye": "blaoe farve",
  "item.minecraft.brown_dye": "bruune farve",
  "item.minecraft.black_dye": "swatte farve",
  "item.minecraft.white_dye": "witte farve",
  "item.minecraft.bone": "been",
  "item.minecraft.sugar": "sucker",
  "block.minecraft.cake": "koken",
  "block.minecraft.white_bed": "wittes bedd",
  "block.minecraft.orange_bed": "geelrootes bedd",
  "block.minecraft.magenta_bed": "magenta bedd",
  "block.minecraft.light_blue_bed": "lechtblaoes bedd",
  "block.minecraft.yellow_bed": "geeles bedd",
  "block.minecraft.lime_bed": "lechtgröönes bedd",
  "block.minecraft.pink_bed": "fienrootes bedd",
  "block.minecraft.gray_bed": "graoes bedd",
  "block.minecraft.light_gray_bed": "grieses bedd",
  "block.minecraft.cyan_bed": "blaogröönes bedd",
  "block.minecraft.purple_bed": "vigelettes bedd",
  "block.minecraft.blue_bed": "blaoes bedd",
  "block.minecraft.brown_bed": "bruunes bedd",
  "block.minecraft.green_bed": "gröönes bedd",
  "block.minecraft.red_bed": "rootes bedd",
  "block.minecraft.black_bed": "swattes bedd",
  "item.minecraft.cookie": "keeks",
  "item.minecraft.filled_map": "kaat□#0",
  "item.minecraft.shears": "scheer",
  "item.minecraft.melon_slice": "meloonschieve",
  "item.minecraft.dried_kelp": "dröögter tang",
  "item.minecraft.pumpkin_seeds": "käverssäöte",
  "item.minecraft.melon_seeds": "meloonsäöte",
  "item.minecraft.beef": "rauhet rindfleesk",
  "item.minecraft.cooked_beef": "steik",
  "item.minecraft.chicken": "rauhet hoönken",
  "item.minecraft.cooked_chicken": "brodten hoönken",
  "item.minecraft.rotten_flesh": "vöruot fleesk",
  "item.minecraft.ender_pearl": "enderparrel",
  "item.minecraft.blaze_rod": "lohenroot",
  "item.minecraft.ghast_tear": "ghasttraan",
  "item.minecraft.gold_nugget": "güldklump",
  "item.minecraft.nether_wart": "netherwaart",
  "item.minecraft.potion": "nich broebar drank□wirkungslos",
  "item.minecraft.glass_bottle": "glasbuddel",
  "item.minecraft.spider_eye": "spennauge",
  "item.minecraft.fermented_spider_eye": "fermentiertes spennauge",
  "item.minecraft.blaze_powder": "lohenstoff",
  "item.minecraft.magma_cream": "magmakreem",
  "block.minecraft.brewing_stand": "brustand",
  "block.minecraft.cauldron": "ketel",
  "item.minecraft.ender_eye": "enderoog",
  "item.minecraft.glistering_melon_slice": "glinsteren meloonenschiev",
  "item.minecraft.bat_spawn_egg": "fleddermuus-spawn-ai",
  "item.minecraft.bee_spawn_egg": "imme-spawn-ai",
  "item.minecraft.blaze_spawn_egg": "lohe-spawn-ai",
  "item.minecraft.cat_spawn_egg": "katt-spawn-ai",
  "item.minecraft.cave_spider_spawn_egg": "hüölenspenn-spawn-ai",
  "item.minecraft.chicken_spawn_egg": "hohn-spawn-ai",
  "item.minecraft.cod_spawn_egg": "kabeljauw-spawn-ai",
  "item.minecraft.cow_spawn_egg": "kau-spawn-ai",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-ai",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-ai",
  "item.minecraft.donkey_spawn_egg": "esel-spawn-ai",
  "item.minecraft.drowned_spawn_egg": "vordrunkenen-spawn-ai",
  "item.minecraft.elder_guardian_spawn_egg": "grooter-wachter-spawn-ai",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-ai",
  "item.minecraft.endermite_spawn_egg": "endermiten-spawn-ai",
  "item.minecraft.evoker_spawn_egg": "magister-spawn-ai",
  "item.minecraft.fox_spawn_egg": "voss-spawn-ai",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-ai",
  "item.minecraft.guardian_spawn_egg": "wachter-spawn-ai",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-ai",
  "item.minecraft.horse_spawn_egg": "peerde-spawn-ai",
  "item.minecraft.husk_spawn_egg": "wüüstenzombie-spawn-ai",
  "item.minecraft.llama_spawn_egg": "lama-spawn-ai",
  "item.minecraft.magma_cube_spawn_egg": "magmawörpel-spawn-ai",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-ai",
  "item.minecraft.mule_spawn_egg": "muuldier-spawn-ai",
  "item.minecraft.ocelot_spawn_egg": "otselot-spawn-ai",
  "item.minecraft.panda_spawn_egg": "panda-spawn-ai",
  "item.minecraft.parrot_spawn_egg": "papagoien-spawn-ai",
  "item.minecraft.phantom_spawn_egg": "fantoom-spawn-ai",
  "item.minecraft.pig_spawn_egg": "swien-spawn-ai",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-ai",
  "item.minecraft.pillager_spawn_egg": "plünner-spawn-ai",
  "item.minecraft.polar_bear_spawn_egg": "iesbaar-spawn-ai",
  "item.minecraft.pufferfish_spawn_egg": "kugelfisk-spawn-ai",
  "item.minecraft.rabbit_spawn_egg": "kanickel-spawn-ai",
  "item.minecraft.ravager_spawn_egg": "verwööster-spawn-ai",
  "item.minecraft.salmon_spawn_egg": "las-spawn-ai",
  "item.minecraft.sheep_spawn_egg": "schap-spawn-ai",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-ai",
  "item.minecraft.silverfish_spawn_egg": "sülwerfisken-spawn-ai",
  "item.minecraft.skeleton_spawn_egg": "skelet-spawn-ai",
  "item.minecraft.skeleton_horse_spawn_egg": "skeletpeerd-spawn-ai",
  "item.minecraft.slime_spawn_egg": "sliem-spawn-ai",
  "item.minecraft.spider_spawn_egg": "spenn-spawn-ai",
  "item.minecraft.squid_spawn_egg": "enktfisk-spawn-ai",
  "item.minecraft.stray_spawn_egg": "ieswander-spawn-ai",
  "item.minecraft.strider_spawn_egg": "lawaloper-spawn-ai",
  "item.minecraft.trader_llama_spawn_egg": "hannelsmann-lama-spawn-ai",
  "item.minecraft.tropical_fish_spawn_egg": "troopenfisk-spawn-ai",
  "item.minecraft.turtle_spawn_egg": "skildpad-spawn-ai",
  "item.minecraft.vex_spawn_egg": "plagegeest-spawn-ai",
  "item.minecraft.villager_spawn_egg": "dörpsbewahner-spawn-ai",
  "item.minecraft.vindicator_spawn_egg": "dener-spawn-ai",
  "item.minecraft.wandering_trader_spawn_egg": "wannernde-hannelsmann-spawn-ai",
  "item.minecraft.witch_spawn_egg": "hex-spawn-ai",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelet-spawn-ai",
  "item.minecraft.wolf_spawn_egg": "wulf-spawn-ai",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-ai",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-ai",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepeerd-spawn-ai",
  "item.minecraft.zombie_villager_spawn_egg": "dörpsbewahnerzombie-spawn-ai",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifiiert-piglin-spawn-ai",
  "item.minecraft.experience_bottle": "erfaorungsbuddel",
  "item.minecraft.fire_charge": "füerbal",
  "item.minecraft.writable_book": "book un fiäder",
  "item.minecraft.written_book": "schriëwen book",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "raam",
  "block.minecraft.flower_pot": "blöömpott",
  "item.minecraft.carrot": "wuddel",
  "item.minecraft.potato": "kartuffel",
  "item.minecraft.baked_potato": "ovendkartuffel",
  "item.minecraft.poisonous_potato": "giftege kartuffel",
  "item.minecraft.map": "leege kaat",
  "item.minecraft.golden_carrot": "güllene wuddel",
  "block.minecraft.skeleton_skull": "skeletkopp",
  "block.minecraft.wither_skeleton_skull": "witherskeletkopp",
  "block.minecraft.player_head": "speelerkopp",
  "block.minecraft.zombie_head": "zombiekopp",
  "block.minecraft.creeper_head": "creeperkopp",
  "block.minecraft.dragon_head": "draakkopp",
  "item.minecraft.carrot_on_a_stick": "wuddelroot",
  "item.minecraft.warped_fungus_on_a_stick": "wierpilzroot",
  "item.minecraft.nether_star": "nethersteern",
  "item.minecraft.pumpkin_pie": "käverskoken",
  "item.minecraft.firework_rocket": "füerwiärksrakeet",
  "item.minecraft.firework_star": "füerwiärksstään",
  "item.minecraft.enchanted_book": "betövert book",
  "item.minecraft.nether_brick": "nethertegel",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-kaor",
  "item.minecraft.hopper_minecart": "trächterkaor",
  "item.minecraft.prismarine_shard": "prismariensplaot",
  "item.minecraft.prismarine_crystals": "prismarienkristallen",
  "item.minecraft.rabbit": "rauhet kanickel",
  "item.minecraft.cooked_rabbit": "brodten kanickel",
  "item.minecraft.rabbit_stew": "kanickelragout",
  "item.minecraft.rabbit_foot": "haasenpoot",
  "item.minecraft.rabbit_hide": "kanickelfell",
  "item.minecraft.armor_stand": "rüststänner",
  "item.minecraft.iron_horse_armor": "isderne peerderüst",
  "item.minecraft.golden_horse_armor": "güllene peerderüst",
  "item.minecraft.diamond_horse_armor": "demanter peerderüst",
  "item.minecraft.leather_horse_armor": "liäderne peerderüst",
  "item.minecraft.lead": "line",
  "item.minecraft.name_tag": "naamschild",
  "item.minecraft.command_block_minecart": "befiälskaor",
  "item.minecraft.mutton": "rauhet lobbenfleesk",
  "item.minecraft.cooked_mutton": "brodten lobbenfleesk",
  "block.minecraft.white_banner": "wittes banner",
  "block.minecraft.orange_banner": "geelrootes banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "lechtblaoes banner",
  "block.minecraft.yellow_banner": "geeles banner",
  "block.minecraft.lime_banner": "lechtgröönes banner",
  "block.minecraft.pink_banner": "fienrootes banner",
  "block.minecraft.gray_banner": "graoes banner",
  "block.minecraft.light_gray_banner": "grieses banner",
  "block.minecraft.cyan_banner": "blaogröönes banner",
  "block.minecraft.purple_banner": "vigelettes banner",
  "block.minecraft.blue_banner": "blaoes banner",
  "block.minecraft.brown_banner": "bruunes banner",
  "block.minecraft.green_banner": "gröönes banner",
  "block.minecraft.red_banner": "rootes banner",
  "block.minecraft.black_banner": "swattes banner",
  "item.minecraft.end_crystal": "endkristaal",
  "item.minecraft.chorus_fruit": "chorusfrücht",
  "item.minecraft.popped_chorus_fruit": "platzt chorusfrücht",
  "item.minecraft.beetroot": "roote beet",
  "item.minecraft.beetroot_seeds": "roote-beet-säöte",
  "item.minecraft.beetroot_soup": "borscht",
  "item.minecraft.dragon_breath": "draakaam",
  "item.minecraft.splash_potion": "neet braubarer smeetdrank□wirkungslos",
  "item.minecraft.spectral_arrow": "spektraalpiel",
  "item.minecraft.tipped_arrow": "nich herstellig drankt piel□wirkungslos",
  "item.minecraft.lingering_potion": "neet braubarerer wieldrank□wirkungslos",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "elytren",
  "item.minecraft.spruce_boat": "füchtenholtbööd",
  "item.minecraft.birch_boat": "biäkenholtbööd",
  "item.minecraft.jungle_boat": "oorwooldholtbööd",
  "item.minecraft.acacia_boat": "akatsienholtbööd",
  "item.minecraft.dark_oak_boat": "swatekenholtbööd",
  "item.minecraft.totem_of_undying": "totem van unstarvigkeeit",
  "item.minecraft.shulker_shell": "shulker-schaal",
  "item.minecraft.iron_nugget": "isenklump",
  "item.minecraft.knowledge_book": "book vun weten",
  "item.minecraft.debug_stick": "debugstok",
  "item.minecraft.music_disc_13": "schalplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "schalplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "schalplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schalplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "schalplaat□c418 - far",
  "item.minecraft.music_disc_mall": "schalplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schalplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schalplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "schalplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "schalplaat□c418 - ward",
  "item.minecraft.music_disc_11": "schalplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "schalplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schalplaat□lena raine - pigstep",
  "item.minecraft.trident": "dreetack□□in de hööfthand:□+8 anslagsschaden□-2.9 angriffgauigkait",
  "item.minecraft.phantom_membrane": "fantoomhuut",
  "item.minecraft.nautilus_shell": "nautilusschaal",
  "item.minecraft.heart_of_the_sea": "hart vun de see",
  "item.minecraft.crossbow": "armborst",
  "item.minecraft.suspicious_stew": "seelsame sopp",
  "block.minecraft.loom": "weevstohl",
  "item.minecraft.flower_banner_pattern": "lappkevörlaag□blööm",
  "item.minecraft.creeper_banner_pattern": "lappkevörlaag□creeper",
  "item.minecraft.skull_banner_pattern": "lappkevörlaag□kopp",
  "item.minecraft.mojang_banner_pattern": "lappkevörlaag□mojang-wapen",
  "item.minecraft.globe_banner_pattern": "lappkevörlaag□eer",
  "item.minecraft.piglin_banner_pattern": "lappkevörlaag□schnut",
  "block.minecraft.composter": "kumposter",
  "block.minecraft.barrel": "fatt",
  "block.minecraft.smoker": "rökelaven",
  "block.minecraft.blast_furnace": "smöltaven",
  "block.minecraft.cartography_table": "kaarttafel",
  "block.minecraft.fletching_table": "buogtafel",
  "block.minecraft.grindstone": "sliepsteen",
  "block.minecraft.lectern": "leespult",
  "block.minecraft.smithing_table": "smitgtafel",
  "block.minecraft.stonecutter": "steensaag",
  "block.minecraft.bell": "klock",
  "block.minecraft.lantern": "lateern",
  "block.minecraft.soul_lantern": "siälenlatern",
  "item.minecraft.sweet_berries": "söötbeje",
  "block.minecraft.campfire": "loagafia",
  "block.minecraft.soul_campfire": "siälenloagafia",
  "block.minecraft.shroomlight": "poggenstoollücht",
  "item.minecraft.honeycomb": "hönnigwaar",
  "block.minecraft.bee_nest": "immennest",
  "block.minecraft.beehive": "immenstock",
  "item.minecraft.honey_bottle": "hönnigbuddel",
  "block.minecraft.honey_block": "hönnigblok",
  "block.minecraft.honeycomb_block": "hönnigwaarblok",
  "block.minecraft.lodestone": "leitsteen",
  "block.minecraft.netherite_block": "netheritblok",
  "block.minecraft.ancient_debris": "antiker schroot",
  "block.minecraft.target": "teelblok",
  "block.minecraft.crying_obsidian": "wienner gnetersteen",
  "block.minecraft.blackstone": "swatsteen",
  "block.minecraft.blackstone_slab": "swatsteenplaat",
  "block.minecraft.blackstone_stairs": "swatsteentrapp",
  "block.minecraft.gilded_blackstone": "gülddörsnitt swatsteen",
  "block.minecraft.polished_blackstone": "poleerter swatsteen",
  "block.minecraft.polished_blackstone_slab": "poleerte swatsteenplaat",
  "block.minecraft.polished_blackstone_stairs": "poleerte swatsteentrapp",
  "block.minecraft.chiseled_polished_blackstone": "baitelt poleerter swatsteen",
  "block.minecraft.polished_blackstone_bricks": "poleerte swatsteentegel",
  "block.minecraft.polished_blackstone_brick_slab": "poleerte swatsteentegelplaat",
  "block.minecraft.polished_blackstone_brick_stairs": "poleerte swatsteentegeltrapp",
  "block.minecraft.cracked_polished_blackstone_bricks": "bürstige poleerte swatsteentegel",
  "block.minecraft.respawn_anchor": "seelanker",
}
export const nds_de = items; 
